import React from 'react';
import { compose } from 'redux';

import { Button } from "react-bootstrap";

import {
  cloneDeep, orderBy
} from 'lodash';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';


import {
  Paginator, PrimaryControls, paginate
} from '../tableHelpers';


import _ from 'underscore';

import { MobileCardList, MobileCard } from '../common/MobileCard';

import { translate } from 'react-i18next';

@translate(['common'])

export default class TicketList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: this.props.tickets, // initial rows
      searchColumn: 'all',
      query: {}, // search query
      sortingColumns: null, // reference to the sorting columns
      columns: this.getColumns(), // initial columns
      pagination: { // initial pagination settings
        page: 1,
        perPage: 10
      },
      mAreaVisible: true,
      messageArea: ''
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.messageAreaChange = this.messageAreaChange.bind(this);
  }

  messageAreaChange(e) {

    this.setState({ messageArea: e.target.value })
  }


  componentDidUpdate(prevProps) {
    if (prevProps.tickets !== this.props.tickets) {
      this.setState({ rows: this.props.tickets })
    }
  }


  getColumns() {

    var self = this;

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({ // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);


    return [
      {
        property: 'id',
        header: {
          label: 'ID',
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },
      {
        property: 'date_reference',
        header: {
          label: 'Date',
          formatters: [sortableHeader],
          props: {
            className: "col-md-2"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },

      {
        property: 'description',
        header: {
          label: 'Description',
          formatters: [sortableHeader],
          props: {
            className: "col-md-3"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },

      {
        property: 'etat',
        header: {
          label: 'État',
          formatters: [sortableHeader],
          props: {
            className: "col-md-1"
          }
        },
        cell: {
          formatters: [
            search.highlightCell
          ]
        },
        visible: true
      },


      {
        property: 'messages',
        header: {
          label: 'Messages',
          formatters: [sortableHeader, (value, { rowData }) => {
            return <span>Messages &nbsp;
          	 </span>

          }],
          props: {
            className: "col-md-4"
          }
        },
        cell: {

          property: 'messages',
          formatters: [(value, extras) => {

            var messages = extras.rowData.messages ? extras.rowData.messages.split('$$$$$') : [];

            var m_array = [];
            _.each(messages, (m) => {

              m = m.split('%')

              m_array.push(<div>{m[0]} <b>{m[1]}</b> : <br />{m[2]}{/*search.highlightCell(m,extras)*/}<hr style={{ 'margin': '5px', 'borderColor': 'grey' }} /></div>)
            })

            var self = this;




            return (


              <div style={{ 'maxHeight': '100px', 'overflowY': 'scroll' }}>


                {m_array}


              </div>
            )


          }]
        },
        visible: true
      }, {

        cell: {

          formatters: [(value, { rowData }) => {
            var self = this;



            return (


              <div >

                <span style={{ 'position': 'relative' }}>
                  <textarea style={{ resize: 'none' }} id={'area_' + rowData.id} />

                  <Button onClick={() => {
                    var message = document.getElementById('area_' + rowData.id).value;
                    self.props.createMessage(message, rowData.id, self.props.params)
                  }} bsStyle='primary' bsSize="xsmall">
                    Créer le message
	      	 	 </Button>

                </span>


              </div>
            )


          }]
        },
        visible: true
      }

    ];

  }

  render() {

    const {t} = this.props

    var columns = this.getColumns()


    const {
       rows, pagination, sortingColumns, searchColumn, query
    } = this.state;

    const cols = columns.filter(column => column.visible);
    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(rows);

    return (
      <div>
        {/*<VisibilityToggles
          columns={columns}
          onToggleColumn={this.onToggleColumn}
        />*/}

        <PrimaryControls
          className="controls"
          perPage={pagination.perPage}
          column={searchColumn}
          query={query}
          columns={cols}
          rows={rows}
          onPerPage={this.onPerPage}
          onColumnChange={this.onColumnChange}
          onSearch={this.onSearch}
          t={t}
        />

        <MobileCardList>
          {paginated.rows.map((rowData) => {
            const messages = rowData.messages ? rowData.messages.split('$$$$$') : [];
            return (
              <MobileCard
                key={rowData.id}
                title={'#' + rowData.id}
                badge={rowData.etat}
                subtitle={rowData.date_reference}
                fields={[
                  { value: rowData.description },
                  messages.length > 0 && {
                    label: 'Messages',
                    value: (
                      <div style={{ maxHeight: '150px', overflowY: 'auto', marginTop: '4px' }}>
                        {messages.map((m, i) => {
                          m = m.split('%')
                          return <div key={i} style={{ borderTop: '1px solid #eee', padding: '3px 0' }}>{m[0]} <b>{m[1]}</b> :<br />{m[2]}</div>
                        })}
                      </div>
                    )
                  }
                ]}
                actions={
                  <div style={{ width: '100%' }}>
                    <textarea className="form-control" rows="2" style={{ resize: 'none', marginBottom: '5px' }} id={'m_area_' + rowData.id} />
                    <Button bsStyle='primary' bsSize="sm" block onClick={() => {
                      var message = document.getElementById('m_area_' + rowData.id).value;
                      this.props.createMessage(message, rowData.id, this.props.params)
                    }}>
                      Créer le message
                    </Button>
                  </div>
                }
              />
            )
          })}
        </MobileCardList>

        <div className="hidden-xs">
        <Table.Provider
          className="table table-striped"
          columns={cols}
          style={{ overflowX: 'auto' }}
        >
          <Table.Header>
            {/*<SearchColumns query={query} columns={cols} onChange={this.onSearch} />*/}
          </Table.Header>

          <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

          {/*<CustomFooter columns={cols} rows={paginated.rows} />*/}
        </Table.Provider>
        </div>

        <div className="controls">
          <Paginator
            pagination={pagination}
            pages={paginated.amount}
            onSelect={this.onSelect}
            prevText={t("pagination.previous")}
            nextText={t("pagination.next")}
          />
        </div>
      </div>
    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
  }
  onSelect(page) {
    const pages = Math.ceil(
      this.state.rows.length / this.state.pagination.perPage
    );

    this.setState({
      pagination: {
        ...this.state.pagination,
        page: Math.min(Math.max(page, 1), pages)
      }
    });
  }
  onPerPage(value) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        perPage: parseInt(value, 10)
      }
    });
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}